import { get, post, put } from '@api/request';

export async function fetchAppealPanels(
  { appealsService },
  authenticationToken,
  { panelType = '' }
) {
  const url = `${appealsService}/prodigyappeals/appealpanels?panelType=${panelType}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAppealPanelDirectAssignments(
  { appealsService },
  authenticationToken,
  { panelID }
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelID}/directassignments`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function startMeeting(
  { appealsService },
  authenticationToken,
  { panelID, payload }
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelID}/startmeeting`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function getNextCaseForPanel(
  { appealsService },
  authenticationToken,
  { panelID, pID }
) {
  var url = `${appealsService}/prodigyappeals/appealpanel/${panelID}/nextcheckin`;
  if (pID && pID.length > 0) {
    url =`${url}?pID=${pID}`
  }
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function takeappeal(
  { appealsService },
  authenticationToken,
  { panelID, payload }
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelID}/takecheckin`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function returnCurrentAppeal(
  { appealsService },
  authenticationToken,
  { panelID, payload }
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelID}/returncurrentcheckin`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function directAssignmentTakeAppeal(
  { appealsService },
  authenticationToken,
  { appealPanelAssignmentID }
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/directassignment/${appealPanelAssignmentID}/takecheckin`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function returnToWaitingRoom(
  { appealsService },
  authenticationToken,
  { appealPanelAssignmentID, payload }
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/directassignment/${appealPanelAssignmentID}/returncheckin`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}


export async function getCurrentAppealForPanel(
  { appealsService },
  authenticationToken,
  { panelID }
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelID}/currentcheckin`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getDailyStatisticsForPanel(
  { appealsService },
  authenticationToken,
  { panelID }
) {
  const url = `${appealsService}/prodigyappeals/appealpanel/${panelID}/dailystatistics`;
  const { body } = await get(authenticationToken, url);
  return body;
}